import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "g-content" };
const _hoisted_2 = {
    key: 0,
    class: "container-fluid w-100 pt-2 pb-2 mb-3",
    style: { "border-bottom": "1px dashed #dee2e6" }
};
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-8 pl-2" };
const _hoisted_5 = { class: "col-4 pr-2 command-bar" };
const _hoisted_6 = { class: "container-fluid p-0 h-100" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = {
    key: 0,
    class: "d-none d-lg-block col-lg-3 col-xl-3 pe-0 border-end"
};
const _hoisted_9 = {
    key: 1,
    class: "g-navpane__footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_portal_target = _resolveComponent("portal-target");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showCommandBar && this.$slots.title || this.$slots.commands)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "title")
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_portal_target, {
                            name: "command-bar",
                            multiple: ""
                        })
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                (this.$slots.sidebar)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _renderSlot(_ctx.$slots, "sidebar")
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass([this.$slots.sidebar ? 'col-lg-9 col-xl-9' : 'col-lg-12 p-0'])
                }, [
                    _renderSlot(_ctx.$slots, "content")
                ], 2)
            ])
        ]),
        (this.$slots.footer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _renderSlot(_ctx.$slots, "footer")
            ]))
            : _createCommentVNode("", true)
    ]));
}
